import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import classNames from 'clsx';

import { destroyToast } from 'src/redux/actions/toast';

import Information from '@mdi/svg/svg/information.svg';

import styles from 'src/containers/ToastContainer.scss';


const okText = 'OK';
const animationDuration = 300;
const animationDelay = 50;

// eslint-disable-next-line max-statements
const ToastContainer = () => {
  const { type, message } = useSelector(({ toastReducer }) => ({
    type: toastReducer.type,
    message: toastReducer.message
  }), (previous, next) => (previous.type === next.type) && (previous.message === next.message));

  const [isVisible, setIsVisible] = useState(false);
  const [delayTimerIn, setDelayTimerIn] = useState(null);
  const [delayTimerOut, setDelayTimerOut] = useState(null);

  const dispatch = useDispatch();
  const closeToast = () => {
    setIsVisible(false);
    // Wait for animation out
    setDelayTimerOut(setTimeout(() => dispatch(destroyToast()), animationDuration));
  };

  const classList = classNames({
    [styles.toast]: true,
    [styles['toast--error']]: type === 'error',
    [styles['toast--visible']]: Boolean(isVisible)
  });

  useEffect(() => () => {
    clearTimeout(delayTimerOut);
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);

  useEffect(() => {
    if (message) {
      // Wait for render in DOM
      setDelayTimerIn(setTimeout(() => setIsVisible(true), animationDelay));
    }
    return () => {
      clearTimeout(delayTimerIn);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [message]);

  if (!message) {
    return null;
  }

  return (
    <div className={ classList } data-test="section-toast">
      <div styleName="styles.toast__wrapper">
        <Information styleName="styles.toast__lead-icon" viewBox="0 0 24 24" />
        <p styleName="styles.toast__description">{ message }</p>
        <button
          data-test="button-closeToast"
          onClick={ closeToast }
          styleName="styles.toast__close-button"
          type="button"
        >
          { okText }
        </button>
      </div>
    </div>
  );
};

export default ToastContainer;
